export default __webpack_public_path__ + "static/python-development-company-peerbits-0796c7dc3fbd973230a86398c048febd.png";